module.exports = __webpack_public_path__ + "assets/icon-custom-project-selected.5a6a6366.svg";